module.exports = __webpack_public_path__ + "mt.dd04a697.svg";